"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatSelectionLegends = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'seat-selection-legends';
class SeatSelectionLegends extends react_1.default.PureComponent {
    render() {
        const { title, modificators = 'green' } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("h3", { className: `${className}__title` }, title),
            react_1.default.createElement("div", { className: `${className}__list` },
                react_1.default.createElement("div", { className: `${className}__item` },
                    react_1.default.createElement("div", { className: `${className}__icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'plan-seat-color' })),
                    react_1.default.createElement("div", { className: `${className}__text` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Seat/AircraftSeatsSelection/Legends:AvailableSeats', defaultMessage: 'Seat is available for selection' }))),
                react_1.default.createElement("div", { className: `${className}__item ${className}__item--selected` },
                    react_1.default.createElement("div", { className: `${className}__icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'plan-seat-color' })),
                    react_1.default.createElement("div", { className: `${className}__text` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Seat/AircraftSeatsSelection/Legends:SelectedSeats', defaultMessage: 'Seat is selected' }))),
                react_1.default.createElement("div", { className: `${className}__item ${className}__item--active` },
                    react_1.default.createElement("div", { className: `${className}__icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'plan-seat-color' })),
                    react_1.default.createElement("div", { className: `${className}__text` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Seat/AircraftSeatsSelection/Legends:ActiveSeat', defaultMessage: 'Seat is active' }))),
                react_1.default.createElement("div", { className: `${className}__item ${className}__item--disabled` },
                    react_1.default.createElement("div", { className: `${className}__icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'plan-seat-color' })),
                    react_1.default.createElement("div", { className: `${className}__text` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Seat/AircraftSeatsSelection/Legends:UnavailableSeats', defaultMessage: 'Seat is unavailable' }))))));
    }
}
exports.SeatSelectionLegends = SeatSelectionLegends;
SeatSelectionLegends.defaultProps = {
    title: '',
};
//# sourceMappingURL=index.js.map